// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"96bc3fd5075c9ba6","5058":"8c68d6113632810f","6233":"b4db58aaa5b83abf","6366":"8c68d6113632810f"}[chunkId] + ".css";
};